export const items = [
  {
    title: "House Rent Allowance",
    type: "Percentage",
    value: "25%",
    description: "Calculated from basic",
    category: "ALLOWANCE",
  },
  {
    title: "Professional Tax",
    type: "Fixed Value",
    value: "₹200",
    description: "Mandatory deduction",
    category: "DEDUCTION",
  },
  {
    title: "Medical Allowance",
    type: "Fixed Value",
    value: "₹1,500",
    description: "Fixed monthly allowance",
    category: "ALLOWANCE",
  },
];
